import { useState } from 'react';
import toast from 'react-hot-toast';
import { retryMailApi, signupApi } from '~/api';
import { useBoolean } from '~/hooks/useBoolean';
import { analytics } from '~/services/analyticsService';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';
import { getStoredUtmParams } from '~/utils/utm';

export default function useSignup() {
  const [isLoading, loadingActions] = useBoolean();
  const [isSubmitted, submittedActions] = useBoolean();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isConsent, setIsConsent] = useState(true);

  async function handleSubmit() {
    const trimmedEmail = email.trim();
    const trimmedPass = password.trim();

    if (!trimmedEmail || !trimmedPass) {
      toast.error('Enter valid email and password');
      return;
    }

    loadingActions.on();

    const utmParams = getStoredUtmParams();
    const formData = { email: trimmedEmail, password: trimmedPass };
    const requestData = { ...formData, ...utmParams };

    const promise = signupApi(requestData);
    const response = await apiResponseHandler<{ user_id: number }>(promise);

    if (response.type === ApiResponseEnum.Success) {
      submittedActions.on();
      analytics.identify(response.data.user_id.toString(), {
        email: trimmedEmail,
        plan_type: 'free',
      });
    } else {
      toast.error(response.error.toString());
    }

    loadingActions.off();
  }

  function resetForm() {
    setEmail('');
    setPassword('');
    submittedActions.off();
  }

  async function resendMail() {
    const promise = retryMailApi({ email: email.trim() });
    const response = await apiResponseHandler<{}>(promise);

    if (response.type === ApiResponseEnum.Success) {
      toast.success('Mail sent successfully');
    } else {
      toast.error(response.error.toString());
    }
  }

  return {
    isLoading,
    loadingActions,
    isSubmitted,
    submittedActions,
    email,
    setEmail,
    password,
    setPassword,
    handleSubmit,
    resetForm,
    resendMail,
    isConsent,
    setIsConsent,
  };
}
